  import {
    REQUEST_FETCH_GENERAL_RATE_CABINS,
    FETCH_GENERAL_RATE_CABINS_SUCCESS,
    FETCH_GENERAL_RATE_CABINS_ERROR,
  } from "../../../actions/rates/generalRatesCabin/fetchGeneralRatesCabins";
  
  import {
    REQUEST_CREATE_GENERAL_RATE_CABIN,
    CREATE_GENERAL_RATE_CABIN_SUCCESS,
    CREATE_GENERAL_RATE_CABIN_ERROR,
  } from "../../../actions/rates/generalRatesCabin/createGeneralRatesCabin";
  
  import {
    REQUEST_DELETE_GENERAL_RATE_CABIN,
    DELETE_GENERAL_RATE_CABIN_SUCCESS,
    DELETE_GENERAL_RATE_CABIN_ERROR,
    INITIAL_STATE_GENERAL_RATE_CABIN,
  } from "../../../actions/rates/generalRatesCabin/deleteGeneralRatesCabin";
  
  const initialState = {
    generalRateCabins: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  };
  
  const generalRateCabinReducer = (state = initialState, action) => {
    switch (action.type) { 
      case INITIAL_STATE_GENERAL_RATE_CABIN: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: false,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case REQUEST_FETCH_GENERAL_RATE_CABINS: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: false,
          fetching: true,
          message: "",
          error: "",
        };
      }
      case FETCH_GENERAL_RATE_CABINS_SUCCESS: {
        return {
          ...state,
          generalRateCabins: action.generalRateCabins,
          generalRateCabin: {},
          processing: false,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case FETCH_GENERAL_RATE_CABINS_ERROR: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: false,
          fetching: false,
          message: "",
          error: action.error,
        };
      }
      case REQUEST_CREATE_GENERAL_RATE_CABIN: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: true,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case CREATE_GENERAL_RATE_CABIN_SUCCESS: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: false,
          fetching: false,
          message: action.message,
          error: "",
        };
      }
      case CREATE_GENERAL_RATE_CABIN_ERROR: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: false,
          fetching: false,
          message: "",
          error: action.error,
        };
      }
      case REQUEST_DELETE_GENERAL_RATE_CABIN: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: true,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case DELETE_GENERAL_RATE_CABIN_SUCCESS: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: false,
          fetching: false,
          message: action.message,
          error: "",
        };
      }
      case DELETE_GENERAL_RATE_CABIN_ERROR: {
        return {
          ...state,
          generalRateCabins: [],
          generalRateCabin: {},
          processing: false,
          fetching: false,
          message: "",
          error: action.error,
        };
      }
      default: {
        return state;
      }
    }
  };
  
  export default generalRateCabinReducer;
  